import React, { useEffect, useState } from "react";
import { Space, Input, PageHeader, Select, Button, Card, message, Row, Col } from "antd";
import { useSelector } from "react-redux";
import R2Footer from "../../components/Footer";
import EmployeeService from "../../services/EmployeeService";
import Dragger from "antd/lib/upload/Dragger";
import TestimonialService from "../../services/TestimonialService";
import { UploadOutlined } from "@ant-design/icons";
import back from "../../assets/images/back_arrow.png";

const { Option } = Select;

const AddEditDriver = ({
  setIsDriverAddView,
  selectedDriver,
  setSelectedDriver,
  getDriver,
}) => {
  const adminRestaurant = useSelector((state) => state.admin);
  const [state, setState] = useState({});
  const [previewFile, setPreviewFile] = useState();
  const [file, setFile] = useState("");
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);

  const employeeId = selectedDriver?.id || selectedDriver;

  const getCustomizationList = async () => {
    const res = await EmployeeService.getEmployeType(adminRestaurant);
    setDataList(res.filter((emp) => emp.has_delivery));
  };

  useEffect(() => {
    if (employeeId) {
      EmployeeService.getEmployeeById(employeeId).then((res) => {
        const filterByRes = res.restaurant_roles.find(
          (item) => item.restaurant_id === adminRestaurant
        );
        if (res.id) {
          setState({
            employee_code: filterByRes?.employee_code,
            name: res.name,
            phoneNumber: res.phone_number,
            email: res.email,
            employee_type_id: filterByRes?.employee_type_id,
          });
          if (res.photo_url) {
            setPreviewFile(res.photo_url);
            setFile(res.photo_url);
          }
        }
      });
    }
    getCustomizationList();
  }, []);

  const handleChange = (key, value) => {
    setState({ ...state, [key]: value });
  };

  const submitFile = async (info) => {
    const formData = new FormData();
    formData.append("file", info.file.originFileObj);
    setLoading(true);
    const data = await TestimonialService.uploadPhoto(formData);
    if (data) {
      setPreviewFile(data.url);
      setFile(data.url);
    }
    setLoading(false);
  };

  const handleSubmit = async () => {
    try {
      if (employeeId) {
        const res = await EmployeeService.updateEmployee(
          {
            email: state.email,
            name: state.name,
            phone_number: state.phoneNumber,
            restaurant_ids: [adminRestaurant],
            employee_type_id: state.employee_type_id,
            employee_code: state.employee_code,
            allow_delivery: true,
            photo_url: file,
          },
          employeeId
        );
        if (res.id) {
          message.success("Employee Updated successfully");
          setIsDriverAddView(false);
          // setSelectedDriver(null);
          getDriver();
        }
      } else {
        const res = await EmployeeService.createEmployee({
          email: state.email,
          name: state.name,
          phone_number: state.phoneNumber,
          restaurant_ids: [adminRestaurant],
          employee_type_id: state.employee_type_id,
          employee_code: state.employee_code,
          allow_delivery: true,
          photo_url: file,
        });
        if(res?.err){
          message.error(res?.msg)
        }
        if (res.id) {
          message.success("Employee created successfully");
          setIsDriverAddView(false);
          getDriver();
        }
      }
    } catch (error) {
      message.error(
        "Error creating employee. Please check your input and try again."
      );
    }
  };

  return (
    <>
      <Space className="w-full" direction="vertical">
        <PageHeader
          style={{ minHeight: 80 }}
          className="d-flex page-header-business"
          title={
            <div className="flex items-center">
              <div
                className="cursor-pointer flex"
                onClick={() => setIsDriverAddView(false)}
              >
                <svg
                  width="25"
                  height="16"
                  viewBox="0 0 25 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.292892 7.29289C-0.0976315 7.68342 -0.0976315 8.31658 0.292892 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292892 7.29289ZM25 7L1 7V9L25 9V7Z"
                    fill="black"
                  />
                </svg>
              </div>
              <div className="ml-1 ant-page-header-heading-title">
                {employeeId ? "Edit Driver" : "Add Driver"}
              </div>
            </div>
          }
        />
        <div className="content-container-business box-shadow-card">
          <Card className="add-employee-card" bordered={false}>
            <Row gutter={[16,16]}>
              <Col className="d-flex">
            <div>
              {previewFile ? (
                <div className="preview-file">
                  <img
                    src={previewFile}
                    alt="profile"
                    className="preview-img"
                  />
                  <Button onClick={() => setPreviewFile()}>
                    Change Profile pic
                  </Button>
                </div>
              ) : (
                <Dragger
                  onChange={submitFile}
                  maxCount={1}
                  style={{ marginBottom: "10px" }}
                >
                  <p className="ant-upload-drag-icon">
                    <UploadOutlined />
                  </p>
                  <p className="ant-upload-text">
                    Click or drag file to this area to upload
                  </p>
                </Dragger>
              )}
            </div>
            </Col>
            <Col>
            <form
              className="site-layout-background text-left p-1"
              // onSubmit={()=>handleSubmit()}
            >
              <div className="mb-1">
                <label>Name</label>
                <Input
                  placeholder="Name"
                  name="name"
                  value={state.name}
                  onChange={(e) => {
                    handleChange("name", e.target.value);
                  }}
                />
              </div>
              <div className="mb-1">
                <label>Email</label>
                <Input
                  placeholder="Email"
                  name="name"
                  value={state.email}
                  onChange={(e) => {
                    handleChange("email", e.target.value);
                  }}
                />
              </div>
              <div className="mb-1">
                <label className="d-block">Employee Type</label>
                <Select
                  value={state.employee_type_id}
                  className="w-full"
                  placeholder="Employee Type"
                  onChange={(v) => handleChange("employee_type_id", v)}
                >
                  {dataList?.map((itm) => (
                    <Option key={itm.id} value={itm.id}>
                      {itm.name}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="d-flex w-full mb-1" style={{ flexWrap: "wrap" }}>
                <div className="flex-1">
                  <label>Phone Number</label>
                  <Input
                    placeholder="Phone Number"
                    name="PhoneNumber"
                    autoComplete="tel"
                    type="number"
                    value={state.phoneNumber}
                    onChange={(e) => {
                      handleChange("phoneNumber", e.target.value);
                    }}
                  />
                </div>
                <div className="flex-1 ml-1">
                  <label>Employee Code</label>
                  <Input
                    placeholder="employee_code"
                    name=""
                    value={state.employee_code}
                    onChange={(e) => {
                      handleChange("employee_code", e.target.value);
                    }}
                  />
                </div>
              </div>
              <div className="submit-btn">
                <Button
                  className="mt-1 custom-btn"
                  type="primary"
                  onClick={() => handleSubmit()}
                >
                  Save
                </Button>
              </div>
            </form>
            </Col>
            </Row>
          </Card>
        </div>
      </Space>
      <R2Footer />
    </>
  );
};

export default AddEditDriver;
